import React from 'react'

const SkinsList = () => (
    <div>
        <h1>Skins</h1>
    </div>
)

export default SkinsList